const DB_NAME = 'mmc';
const ESI_STORE_NAME = 'esi';

export interface EsiRecord {
  id: string;
  data: ArrayBuffer;
}

export class MotionMasterClientIndexedDB {
  db: IDBDatabase | null = null;

  open(): Promise<IDBDatabase> {
    return new Promise<IDBDatabase>((resolve, reject) => {
      if (this.db) {
        return resolve(this.db);
      }

      const request: IDBOpenDBRequest = indexedDB.open(DB_NAME, 1);

      request.onsuccess = (event: Event) => {
        // console.log('onsuccess');
        this.db = (event.target as IDBOpenDBRequest).result;
        resolve(this.db);
      };

      request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
        // console.log('onupgradeneeded');
        const db = (event.target as IDBOpenDBRequest).result;

        // Create an object store if it doesn't exist
        if (!db.objectStoreNames.contains(ESI_STORE_NAME)) {
          db.createObjectStore(ESI_STORE_NAME, { keyPath: 'id' });
        }
      };

      request.onerror = (event: Event) => {
        // console.error('Error opening database:', (event.target as IDBOpenDBRequest).error);
        reject((event.target as IDBOpenDBRequest).error);
      };
    });
  }

  putEsi(key: string, data: Uint8Array): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (!this.db) {
        reject('Database not initialized');
        return;
      }

      const transaction = this.db.transaction(ESI_STORE_NAME, 'readwrite');
      const store = transaction.objectStore(ESI_STORE_NAME);

      const record: EsiRecord = { id: key, data: data.buffer };

      const request = store.put(record);

      request.onsuccess = () => {
        // console.log(`Data stored successfully for key: ${key}`);
        resolve();
      };

      request.onerror = (event: Event) => {
        const error = (event.target as IDBRequest).error;
        // console.error('Error storing data:', error);
        reject(error);
      };
    });
  }

  getEsi(key: string): Promise<Uint8Array | null> {
    return new Promise<Uint8Array | null>((resolve, reject) => {
      if (!this.db) {
        reject('Database not initialized');
        return;
      }

      const transaction = this.db.transaction(ESI_STORE_NAME, 'readonly');
      const store = transaction.objectStore(ESI_STORE_NAME);

      const request = store.get(key);

      request.onsuccess = () => {
        const record: EsiRecord = request.result;
        if (record) {
          resolve(new Uint8Array(record.data));
        } else {
          resolve(null);
        }
      };

      request.onerror = (event: Event) => {
        const error = (event.target as IDBRequest).error;
        // console.error('Error loading data:', error);
        reject(error);
      };
    });
  }
}
